import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService, ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioFilter } from '../../filter';
import { NegocioSearchView } from '../../negocio-search-view';
import { NegocioQualificacaoSearch } from '../negocio-qualificacao-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioQualificacaoSearchHttpService {
    private pathApi: string;

    constructor(private authService: AuthService,
                configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negocioqualificacao`;
    }

    /** Realiza a pesquisa do Search View das qualificações de negócios */
    searchView(idFunilVenda: number, filter: NegocioFilter, orderByColumn: number, orderByDir: string): Observable<NegocioSearchView> {
        let params = new HttpParams();

        // Funil de Venda
        if (idFunilVenda) {
            params = params.append('idFunilVenda', idFunilVenda.toString());
        }

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderByColumn ? orderByColumn.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        return this.customHttp.get<NegocioSearchView>(`${this.pathApi}/0/view`, {params});
    }

    /** Realiza a pesquisa das qualificações de negócios */
    search(idsQualificacoes: number[], orderByColumn: number, orderByDir: string): Observable<NegocioQualificacaoSearch[]> {
        let params = new HttpParams();

        // IDs Qualificações
        if (idsQualificacoes && idsQualificacoes.length > 0) {
            idsQualificacoes.forEach(idQualificacao => params = params.append('idQualificacao', idQualificacao.toString()));
        } else {
            params = params.append('idQualificacao', '0'); // Para não trazer nada
        }

        // Order By
        params = params.append('orderBy', orderByColumn ? orderByColumn.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        return this.customHttp.get<NegocioQualificacaoSearch[]>(this.pathApi, {params});
    }

    /** Pesquisa uma única qualificação de negócio através do ID informado */
    searchOne(idQualificacao: number): Observable<NegocioQualificacaoSearch> {
        return this.customHttp.get<NegocioQualificacaoSearch>(`${this.pathApi}/${idQualificacao}/search`);
    }
}
